// extracted by css-extract-rspack-plugin
export default {"backButton":"backButton-lQ5Trt"};